export const createTrackingClosure = initialValue => {
  // Used to pass around a value that code needs to know if it changes in the future
  // Similar to passing getState instead of state, but for a specific value
  //
  // Example Use:
  // const foo = createTrackingClosure(5);
  // foo() // 5
  // foo(3) // 3
  // foo() // 3

  let toTrack = initialValue;
  return (...newValueArgs) => {
    toTrack = newValueArgs.length ? newValueArgs[0] : toTrack;
    return toTrack;
  };
};
